import { createAuthClient } from 'better-auth/react';
import { organizationClient, adminClient } from 'better-auth/client/plugins';

/** better-auth is mounted at `/api/auth` on the server; the client reaches it
 *  through the `/data` dev proxy (and nginx in prod). Sessions are httpOnly
 *  cookies — nothing is stored in localStorage. */
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/data/api/auth`,
  plugins: [organizationClient(), adminClient()],
});

export const { useSession, signIn, signOut } = authClient;
